import { render, staticRenderFns } from "./registrationLogin.vue?vue&type=template&id=6d15bb86&scoped=true&"
import script from "./registrationLogin.vue?vue&type=script&lang=js&"
export * from "./registrationLogin.vue?vue&type=script&lang=js&"
import style0 from "./registrationLogin.vue?vue&type=style&index=0&id=6d15bb86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d15bb86",
  null
  
)

export default component.exports